import Layout from '@/component/Layout/Layout'
import { ResultHistoryView } from '@/ui-components/components/ResultHistory/ResultHistoryView'
import useResultHistory from './hooks/useResultHistory'

const ResultHistoryPage = () => {
  const hookData = useResultHistory()

  return (
    <Layout>
      <ResultHistoryView {...hookData} />
    </Layout>
  )
}

export default ResultHistoryPage
